export const usePermission = () => {
  return {
    loading: false,
    allowedToOpenPage: false,
  };
};
